import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoLocation } from '@smg-real-estate/geo-libs';
import { computed, type Ref } from 'vue';
import { useRoute, type Route, type RouteLocationNormalized } from 'vue-router';

import { isAgentHomeRouteName } from '@/helpers/Url/Url';
import { useAgencyProfilesStore } from '@/stores/agencyProfiles';
import { useAgentProfilesStore } from '@/stores/agentProfiles';

export interface RouteMeta {
  locale: HgSupportedLanguage;
  getLanguageSwitchLink: (
    route: Route,
    language: HgSupportedLanguage,
    selectedLocations: GeoLocation[],
  ) => RouteLocationNormalized;
}

const useRouteMeta = (): Ref<RouteMeta> => {
  const route = useRoute();
  return computed(() => route.meta as unknown as RouteMeta);
};

export const useLocale = (): Ref<HgSupportedLanguage> => {
  const routeMeta = useRouteMeta();
  return computed(() => routeMeta.value.locale);
};

export const useGetLanguageSwitchLink = (): Ref<(_language: HgSupportedLanguage) => unknown> => {
  const route = useRoute();

  return computed(() => (language: HgSupportedLanguage) => {
    const routeName = route.name?.toString() ?? '';
    const selectedLocations = isAgentHomeRouteName(routeName)
      ? useAgentProfilesStore().selectedLocations
      : useAgencyProfilesStore().selectedLocations;

    if (typeof route.meta?.getLanguageSwitchLink === 'function') {
      return (route.meta as unknown as RouteMeta).getLanguageSwitchLink(
        route,
        language,
        selectedLocations,
      );
    }
  });
};
